export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes1_buy.6fcb9e2d.mp3";